import { client } from '../client';
import { IGMMessage } from './types/IGMMessage';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

export const deleteConversationMessage = async (
  conversationSid: string,
  messageSid: string,
  userRole?: string,
): Promise<IGMMessage> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.delete(`${prefix}/conversations/${conversationSid}/messages/${messageSid}`);
    return data;
  }
  try {
    const { data } = await client.delete(`/conversations/${conversationSid}/messages/${messageSid}`);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.delete(`${collectorPrefix}/conversations/${conversationSid}/messages/${messageSid}`);
      return data;
    }
    throw error;
  }
};
